export default __webpack_public_path__ + "static/media/pants.3b8410fc.png";